import { GOOGLE_ADS_CLICK_ID_PARAM } from '@/lib/constants'

/** Google Ads click ID from the URL, falling back to the cookie persisted by ClickIdTracker. */
export const getGclid = (): string | undefined => {
  if (typeof window === 'undefined') return undefined

  const fromUrl = new URLSearchParams(window.location.search).get(GOOGLE_ADS_CLICK_ID_PARAM)
  if (fromUrl) return fromUrl

  const cookiePrefix = `${GOOGLE_ADS_CLICK_ID_PARAM}=`
  const cookieEntry = document.cookie
    .split(';')
    .map((entry) => entry.trim())
    .find((entry) => entry.startsWith(cookiePrefix))

  if (!cookieEntry) return undefined

  try {
    return decodeURIComponent(cookieEntry.slice(cookiePrefix.length))
  } catch {
    // The cookie domain is shared across subdomains; a writer outside this app may store a malformed value
    return undefined
  }
}
